import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import {
  IDENTIALERT_SUBSCRIPTION,
  IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION,
  IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS,
  IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG,
  IDENTIFIND_SUBSCRIPTION,
  IDENTIFIND_SUBSCRIPTION_ADESTRA_TAG,
  PITPAT_SUBSCRIPTION,
  PITPAT_SUBSCRIPTION_ADESTRA_TAG,
  TRANSFER_OF_KEEPERSHIP_BREEDER,
  TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT,
  TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG,
  FOUR_WEEKS_FREE_EMAIL_ADESTRA_TAG,
  UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG,
} from 'src/app/constants/app.constants';
import { Pet } from 'src/app/interfaces/pet';
import { MembershipSelectStepStates, User, WelcomeGiftStepState } from 'src/app/interfaces/user';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-identibase-sub-appreciation',
  templateUrl: './identibase-sub-appreciation.component.html',
})
export class IdentibaseSubAppreciationComponent implements OnInit, AfterViewInit, OnDestroy {
  public identiSubAdestraTag: string;
  public navRoute: string;
  public isAdestraTagReady: boolean = false;
  public hasEligiblePets: boolean;
  private chipNumber: string | undefined;
  private vetCode: string | undefined;
  public membershipSelectStepCompleted: number;
  public welcomeGiftStepCompleted: number;
  public thankYouMessage: string = 'Thank you for your purchase!';
  private isBrowser: boolean;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _gtmService: GoogleTagManagerService,
    private _membershipOptionsService: MemberShipOptionsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    const eligiblePets = this._activatedRoute.snapshot.data.user.eligiblePets as Pet[];
    this.hasEligiblePets = eligiblePets?.length > 0;
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    const queryParams = this._activatedRoute.snapshot.queryParams;
    const user = this._activatedRoute.snapshot.data.user;
    this.membershipSelectStepCompleted = user.membershipSelectStepCompleted;
    this.welcomeGiftStepCompleted = user.welcomeGiftStepCompleted;
    const isUpgrade = queryParams.isUpgrade?.toLowerCase() === 'true';

    if (queryParams && queryParams.subscriptionType) {
      this.setSubAdestraTagAndNavRoute(queryParams);
      this.pushGTMTag(user, isUpgrade);
    } else {
      this.identiSubAdestraTag = UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG;
      this.navRoute = '/dashboard';
    }

    const isPurchaseMessage = queryParams.subscriptionType !== 'petplan4weeksfree';

    if (!isPurchaseMessage) {
      this.thankYouMessage = 'Your pet’s microchip registration is now complete.';
    }

    this.isAdestraTagReady = true;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      switch (this.navRoute) {
        case '/dashboard':
          if (this.identiSubAdestraTag === TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG) {
            this._router.navigate([this.navRoute], { queryParams: { tokExplore: 'open' } });
            break;
          }
          if (this.hasEligiblePets) {
            this._router.navigate([this.navRoute]);
          }
          this.navigateToDashboardOrPetPlan(this.membershipSelectStepCompleted, this.welcomeGiftStepCompleted, this.navRoute);
          break;
        case '/rehome-pet':
          this._router.navigate([this.navRoute], {
            queryParams: { chipNumber: this.chipNumber, vetCode: this.vetCode },
          });
          break;
        default:
          this._router.navigate([this.navRoute]);
      }
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.isBrowser) {
      localStorage.removeItem("arrived_from_email");
    }
  }

  private navigateToDashboardOrPetPlan(membershipSelectStepCompleted: number, welcomeGiftStepCompleted: number, navRoute: string) {
    if (membershipSelectStepCompleted === MembershipSelectStepStates.Updated && welcomeGiftStepCompleted === WelcomeGiftStepState.NotUpdated) {
      return this._router.navigate(['/welcome-gift']);
    }
    return this._router.navigate([navRoute], { queryParams: { followUs: 'open' } });
  }

  private setSubAdestraTagAndNavRoute(queryParams: Params) {
    const subscriptionType = queryParams.subscriptionType;
    const petId = queryParams.petId;
    const chipNumber = queryParams.chipNumber;
    const vetCode = queryParams.vetCode;

    switch (subscriptionType) {
      case IDENTIBASE_PLUS_SUBSCRIPTION:
        this.identiSubAdestraTag = IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS:
        this.identiSubAdestraTag = IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG;
        this.navRoute = '/account/user-details';
        break;
      case IDENTIALERT_SUBSCRIPTION:
        this.identiSubAdestraTag = IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case IDENTIFIND_SUBSCRIPTION:
        this.identiSubAdestraTag = IDENTIFIND_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case PITPAT_SUBSCRIPTION:
        this.identiSubAdestraTag = PITPAT_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case TRANSFER_OF_KEEPERSHIP_BREEDER:
        this.identiSubAdestraTag = TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      case TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT:
        this.identiSubAdestraTag = TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG;

        if (chipNumber && vetCode) {
          this.navRoute = `/rehome-pet`;
          this.chipNumber = chipNumber;
          this.vetCode = vetCode;
        } else {
          this.navRoute = '/dashboard';
        }
        break;
      
      case 'petplan4weeksfree':
        this.identiSubAdestraTag = FOUR_WEEKS_FREE_EMAIL_ADESTRA_TAG;
        this.navRoute = '/dashboard';
        break;
      default:
        this.identiSubAdestraTag = UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG;
        this.navRoute = '/dashboard';
    }
  }

  private pushGTMTag(user: User, isUpgrade: boolean) {

    if (!isUpgrade) return;

    const productName = this._membershipOptionsService.getUserMembershipName(user);

    this._gtmService.pushTag({
      event: 'conversion',
      send_to: 'W-17046233086/r57wCPLirMAaEP6_o8A_',
      product_name: productName,
      environment: environment.name
    });

  }
}
